// If you are adding a term to the ActionSubject glossary,
// please add a member of the Data team to your PR

export const ActionSubject = {
  accountEmail: 'accountEmail',
  app: 'app',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  attachment: 'attachment',
  avatar: 'avatar',
  badge: 'badge',
  banner: 'banner',
  billingFrequency: 'billingFrequency',
  board: 'board',
  boardBackground: 'boardBackground',
  boardName: 'boardName',
  boardOrganization: 'boardOrganization',
  boardPref: 'boardPref',
  boardStar: 'boardStar',
  boardVisibility: 'boardVisibility',
  businessClass: 'businessClass',
  button: 'button',
  card: 'card',
  cardCopy: 'cardCopy',
  cardComposer: 'cardComposer',
  checkbox: 'checkbox',
  collection: 'collection',
  comment: 'comment',
  commentsPermissions: 'commentsPermissions',
  description: 'description',
  drawer: 'drawer',
  drawerNavigationItem: 'drawerNavigationItem',
  dropdown: 'dropdown',
  dropdownItem: 'dropdownItem',
  dueDate: 'dueDate',
  edit: 'edit',
  editor: 'editor',
  email: 'email',
  embed: 'embed',
  error: 'error',
  feature: 'feature',
  featureFlag: 'featureFlag',
  fetchAvailableSites: 'fetchAvailableSites',
  icon: 'icon',
  inlineDialog: 'inlineDialog',
  input: 'input',
  invitation: 'invitation',
  invitationsPermissions: 'invitationsPermissions',
  inviteAcceptanceNotification: 'inviteAcceptanceNotification',
  label: 'label',
  link: 'link',
  list: 'list',
  locale: 'locale',
  location: 'location',
  member: 'member',
  mention: 'mention',
  menu: 'menu',
  menuItem: 'menuItem',
  modal: 'modal',
  mode: 'mode',
  notification: 'notification',
  observer: 'observer',
  onboarding: 'onboarding',
  option: 'option',
  organization: 'organization',
  overlay: 'overlay', // Use for info boxes, callouts within components
  panel: 'panel',
  payment: 'payment',
  pill: 'pill',
  pluginOperationalEvent: 'pluginOperationalEvent',
  pluginScreenEvent: 'pluginScreenEvent',
  pluginTrackEvent: 'pluginTrackEvent',
  pluginUIEvent: 'pluginUIEvent',
  position: 'position',
  powerUp: 'powerUp',
  prompt: 'prompt',
  primaryEmail: 'primaryEmail',
  radioButton: 'radioButton',
  reaction: 'reaction',
  reactionPicker: 'reactionPicker',
  save: 'save',
  search: 'search',
  secondaryEmail: 'secondaryEmail',
  select: 'select',
  separator: 'separator',
  session: 'session',
  shortcut: 'shortcut', // For keyboard shortcuts
  step: 'step',
  sticker: 'sticker',
  suggestion: 'suggestion',
  survey: 'survey',
  tab: 'tab',
  team: 'team',
  teamBoardDeletionRestriction: 'teamBoardDeletionRestriction',
  teamBoardInvitationRestriction: 'teamBoardInvitationRestriction',
  teamBoardVisibilityRestriction: 'teamBoardVisibilityRestriction',
  teamMembershipRestriction: 'teamMembershipRestriction',
  teamTemplatePicker: 'teamTemplatePicker',
  textField: 'textField',
  tile: 'tile',
  toggle: 'toggle',
  tooltip: 'tooltip',
  trial: 'trial',
  trelloGold: 'trelloGold',
  ui: 'ui', // this should only be used for stock "UI viewed"-type events
  upload: 'upload',
  upsell: 'upsell',
} as const;

export type ActionSubjectType = typeof ActionSubject[keyof typeof ActionSubject];

export const isValidActionSubject = (a: ActionSubjectType) => {
  const validSources = Object.values(ActionSubject);
  return validSources.includes(a);
};
